import Color from 'color';
import { chipClasses, alpha, tableRowClasses, tableCellClasses, createTheme } from '@mui/material';
import { merge } from 'lodash';
import { ArrowDropDownRounded } from '@mui/icons-material';
import React from 'react';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var img$1 = "data:image/png;base64,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";

var error = '#E15554';
var whiteDarkBackground = '#FFFFFF';
var sharedColors = {
    '--annotation-footer': 'rgb(var(--annotation-footer-rgb))',
    '--color-error': error,
    '--color-error-dark': Color(error).darken(0.1).hex(),
    '--color-error-light': Color(error).lighten(0.1).hex(),
    '--charcoal-gray': 'rgb(var(--charcoal-gray-rgb))',
    '--graybackground': 'rgb(var(--graybackground-rgb))',
    '--graybox': 'rgb(var(--graybox-rgb))',
    '--grayDark': 'rgb(var(--grayDark-rgb))',
    '--uberBlack': 'rgb(var(--uberBlack-rgb))',
    '--white': 'rgb(var(--white-rgb))',
    '--whiteDarkBackground': whiteDarkBackground,
};

var colorWarning$1 = '#FFC114';
var grayboxRGB$1 = '231, 228, 235';
var brownGray$1 = '#757575';
var charcoalGrayLight = '#979797';
var whiteTheme = __assign(__assign({}, sharedColors), { '--graybackground-rgb': '255, 255, 255', '--white-rgb': '18, 17, 23', '--charcoal-gray-rgb': '255, 255, 255', '--grayDark-rgb': '244, 243, 246', '--uberBlack-rgb': '244, 243, 246', '--validationBackground': '#F4F3F6', '--graybox-rgb': grayboxRGB$1, '--graybox-light': Color("rgb(" + grayboxRGB$1 + ")").lighten(0.07).hex(), '--graytextLight': brownGray$1, '--grayLightRaw': brownGray$1, '--color-success': '#008A27', '--color-warning': colorWarning$1, '--color-warning-dark': Color(colorWarning$1).darken(0.5).saturate(1).hex(), '--brown-gray': brownGray$1, '--brown-gray-light': Color(brownGray$1).lighten(0.4).hex(), '--charcoal-gray-light': charcoalGrayLight, '--charcoal-gray-light-3': '#9b9a9f', '--content-box-shadow-80': '0 3px 8px 0 rgba(0, 0, 0, 0.15)', '--content-box-shadow-50': '0 3px 8px 0 rgba(0, 0, 0, 0.15)', '--content-box-shadow-25': '0 3px 8px 0 rgba(0, 0, 0, 0.15)', '--content-box-shadow-15': '0 3px 8px 0 rgba(0, 0, 0, 0.15)', '--button-shadow-default': '0 3px 8px 0 rgba(0, 0, 0, 0.25)', '--button-shadow-hover': '0 0 6px 0 rgba(0, 0, 0, 0.15)', '--button-icon-default': brownGray$1, '--user-panel-trigger-bg': '#FFFFFF', '--dropdown-item-hover': '#e7e4eb', '--separator-sidebar': '1px solid rgba(var(--white-rgb), .1)', '--separator-sidebar-darker': '1px solid rgba(var(--white-rgb), .1)', '--separator-magic-grid': '1px solid rgba(var(--white-rgb), .1)', '--separator-tuple-line': '#BFB9CA', '--separator-dropdown': '1px solid rgba(var(--white-rgb), .1)', '--avatar-background': '#FFFFFF', '--circled-icon-aggregate': '#F4F3F6', '--annotation-footer-rgb': '255, 255, 255', '--annotation-footer-shadow': '0 -5px 10px -5px rgba(0, 0, 0, 0.15)', '--annotation-footer-header-shadow': '0 0 20px 0 rgba(0, 0, 0, 0.25)', '--annotation-footer-resizer-gradient-to': '#FFFFFF', '--annotation-document-background': "url(" + img$1 + ")", '--annotation-control-panel-shadow': '0 8px 20px 0 rgba(0,0,0,0.20)', '--annotation-fake-select-background': '#E7E4EB', '--annotation-table-footer': '#F4F3F6', '--annotation-table-cell-highlight': '#BFB9CA', '--annotation-edit-grid-button': 'var(--color-primary)', '--annotation-magic-grid-buttons': 'var(--charcoal-gray-light)', '--selection-panel-background': '#FFFFFF', '--input-inline-background': '#FFFFFF', '--datepicker-shadow': '0 10px 30px 0 rgba(0, 0, 0, 0.25)', '--schema-datapoints-background': '#F8F7F9', '--schema-template-gradient-from': '#F4F3F6', '--schema-template-gradient-to': '#FFFFFF', '--schema-template-background-active': '#FFFFFF', '--schema-template-icon-active': 'var(--color-primary)', '--upload-file-background-rgb': '255, 255, 255', '--upload-file-background-even-rgb': '244, 243, 246', '--upload-loader-track': '#F4F3F6', '--upload-text': 'var(--charcoal-gray-light)', '--loader-bar-track': '#F4F3F6', '--sidebar-workspace-empty-background': '#F9F9FA', '--sidebar-workspace-empty-color': 'var(--charcoal-gray-light)', '--option-focused': 'var(--color-primary)', '--footer-gradient-top': 'rgba(42, 42, 50, 0)', '--status-color-edited': '#0bb3ff' });

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAABnRSTlMAAAAAAABupgeRAAAAG0lEQVR4AWNwsXcHIgayAEzzAIFRMApGwSgAAKTaAyl39kUZAAAAAElFTkSuQmCC";

var colorWarning = '#FFC82D';
var grayboxRGB = '53, 53, 61';
var brownGray = '#979797';
var darkTheme = __assign(__assign({}, sharedColors), { '--graybackground-rgb': '27, 25, 34', '--white-rgb': '255, 255, 255', '--charcoal-gray-rgb': '44, 43, 51', '--grayDark-rgb': '39, 36, 44', '--uberBlack-rgb': '18, 17, 23', '--validationBackground': '#28252d', '--graybox-rgb': grayboxRGB, '--graybox-light': Color("rgb(" + grayboxRGB + ")").lighten(0.3).hex(), '--graytextLight': '#a3a3a6', '--grayLightRaw': '#d3d3d3', '--color-success': '#42b964', '--color-warning': colorWarning, '--color-warning-dark': Color(colorWarning).darken(0.5).saturate(1).hex(), '--brown-gray': brownGray, '--brown-gray-light': Color(brownGray).lighten(0.3).hex(), '--charcoal-gray-light': '#403e46', '--charcoal-gray-light-3': '#747379', '--content-box-shadow-80': '0 3px 8px 0 rgba(0, 0, 0, 0.8)', '--content-box-shadow-50': '0 3px 8px 0 rgba(0, 0, 0, 0.5)', '--content-box-shadow-25': '0 3px 8px 0 rgba(0, 0, 0, 0.25)', '--content-box-shadow-15': '0 3px 8px 0 rgba(0, 0, 0, 0.15)', '--button-shadow-default': '0 3px 8px 0 rgba(0, 0, 0, 0.5)', '--button-shadow-hover': '0 0 6px 0 rgba(0, 0, 0, 0.4)', '--button-icon-default': 'var(--white)', '--user-panel-trigger-bg': 'var(--charcoal-gray-light)', '--dropdown-item-hover': 'var(--charcoal-gray-light)', '--separator-sidebar': '1px solid rgba(var(--white-rgb), .2)', '--separator-sidebar-darker': '1px solid var(--charcoal-gray-light)', '--separator-magic-grid': '1px solid var(--brown-gray)', '--separator-tuple-line': 'var(--graybackground)', '--separator-dropdown': '1px solid var(--charcoal-gray-light)', '--avatar-background': 'var(--charcoal-gray-light)', '--circled-icon-aggregate': 'var(--charcoal-gray)', '--annotation-footer-rgb': 'var(--uberBlack-rgb)', '--annotation-footer-shadow': '0 -5px 10px -5px rgba(0, 0, 0, 0.4)', '--annotation-footer-header-shadow': '0 0 20px 0 rgba(0, 0, 0, 0.51)', '--annotation-footer-resizer-gradient-to': '#38363e', '--annotation-document-background': "url(" + img + ")", '--annotation-control-panel-shadow': 'none', '--annotation-fake-select-background': '#000', '--annotation-table-footer': 'var(--charcoal-gray)', '--annotation-table-cell-highlight': '#696969', '--annotation-edit-grid-button': 'var(--color-primary)', '--annotation-magic-grid-buttons': 'var(--charcoal-gray)', '--selection-panel-background': 'var(--graybox)', '--input-inline-background': 'var(--charcoal-gray-light)', '--datepicker-shadow': '0 10px 30px 0 rgba(0, 0, 0, 0.5)', '--schema-datapoints-background': 'var(--graybackground)', '--schema-template-gradient-from': 'var(--graybackground)', '--schema-template-gradient-to': '#322f36', '--schema-template-background-active': '#322f36', '--schema-template-icon-active': 'var(--white)', '--upload-file-background-rgb': '60, 58, 66', '--upload-file-background-even-rgb': '77, 75, 82', '--upload-loader-track': 'var(--graybox-light)', '--upload-text': 'var(--graybox-light)', '--loader-bar-track': 'var(--charcoal-gray)', '--sidebar-workspace-empty-background': '#211e2a', '--sidebar-workspace-empty-color': '#646464', '--option-focused': 'var(--brown-gray)', '--footer-gradient-top': 'rgba(42, 42, 50, 0)', '--status-color-edited': '#0bb3ff' });

var commonThemeOptions = {
    palette: {
        aurora: {
            main: '#7D06A7',
            light: '#EF9CFD',
            dark: '#550672',
            contrastText: '#FFFFFF',
        },
        other: {
            muted: '#403e46',
        },
        grey: {
            50: '#FFFFFF',
            100: '#F8F8F8',
            200: '#EEEEEE',
            300: '#E0E0E0',
            400: '#BDBDBD',
            500: '#9E9E9E',
            600: '#757575',
            700: '#24252B',
            800: '#151519',
            900: '#000000',
        },
    },
    shape: {
        borderRadius: 4,
        borders: {
            tiny: 3,
            small: 5,
            medium: 10,
            large: 15,
        },
    },
};

// https://www.figma.com/file/AaBwZVqcfaoe476bCiLqmJ/Rossum-Design-System-%E2%80%94-Dark?node-id=6785%3A42814
var darkThemeOptions = {
    palette: {
        mode: 'dark',
        primary: {
            main: '#336EC9',
        },
        secondary: {
            main: '#9ECEF7',
        },
        success: {
            main: '#66BB6A',
        },
        info: {
            main: '#29B6F6',
        },
        warning: {
            main: '#FFA726',
        },
        error: {
            main: '#F44336',
        },
        divider: "rgba(255, 255, 255, 0.12)",
        // TODO: Finally define surfaces behavior
        // there should be consistency between these two colors!
        background: {
            default: '#151519',
            // trial and error to roughly match elevations to our current shades
            // would be nice to also customise shadows in theme 'shadows' property
            paper: '#24252B',
        },
        // TODO: We should probably get rid of this and instead enforce `Menu` to be systematic
        // is connected to the above
        // action: {
        //   hover: 'rgba(255, 255, 255, 0.2)',
        //   hoverOpacity: 0.2,
        // },
    },
};

var lightThemeOptions = {
    palette: {
        mode: 'light',
        primary: {
            main: '#0066F3',
        },
        secondary: {
            main: '#586178',
        },
        success: {
            main: '#66BB6A',
        },
        info: {
            main: '#29B6F6',
        },
        warning: {
            main: '#FFA726',
        },
        error: {
            main: '#F44336',
        },
        divider: "rgba(0, 0, 0, 0.12)",
        background: {
            default: '#fff',
            paper: '#F8F8F8',
        },
        // TODO: We should probably get rid of this and instead enforce `Menu` to be systematic
        // is connected to the above
        // action: {
        //   hover: 'rgba(255, 255, 255, 0.2)',
        //   hoverOpacity: 0.2,
        // },
    },
};

var muiAutocomplete = function (_theme) { return ({
    defaultProps: {
        ChipProps: {
            size: 'small',
        },
    },
}); };

// Please ignore the verbosity of this file, waiting for
// https://github.com/mui-org/material-ui/pull/29610 to be released
// then it will get _much_ shorter
var muiChip = function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return ({
        styleOverrides: {
            root: {
                lineHeight: 1,
            },
            sizeSmall: {
                fontSize: 12,
            },
            iconSmall: {
                fontSize: 18,
            },
            deleteIconSmall: {
                fontSize: 18,
            },
            avatarSmall: {
                width: 18,
                height: 18,
            },
        },
        variants: [
            {
                props: { size: 'tiny' },
                style: (_a = {
                        height: 20,
                        fontSize: 11
                    },
                    _a["& ." + chipClasses.icon] = {
                        fontSize: 14,
                    },
                    _a["& ." + chipClasses.deleteIcon] = {
                        fontSize: 14,
                    },
                    _a["& ." + chipClasses.avatar] = {
                        width: 14,
                        height: 14,
                    },
                    _a),
            },
            {
                props: { variant: 'twoTone', color: 'primary' },
                style: (_b = {
                        color: theme.palette.primary.main,
                        backgroundColor: alpha(theme.palette.primary.main, 0.15)
                    },
                    _b["&:hover"] = {
                        backgroundColor: alpha(theme.palette.primary.main, 0.18),
                    },
                    _b["& ." + chipClasses.icon] = {
                        color: alpha(theme.palette.primary.main, 0.8),
                    },
                    _b["& ." + chipClasses.deleteIcon] = (_c = {
                            color: alpha(theme.palette.primary.main, 0.8)
                        },
                        _c["&:hover"] = {
                            color: theme.palette.primary.main,
                        },
                        _c),
                    _b),
            },
            {
                props: { variant: 'twoTone', color: 'error' },
                style: (_d = {
                        color: theme.palette.error.main,
                        backgroundColor: alpha(theme.palette.error.main, 0.15)
                    },
                    _d["&:hover"] = {
                        backgroundColor: alpha(theme.palette.error.main, 0.18),
                    },
                    _d["& ." + chipClasses.icon] = {
                        color: alpha(theme.palette.error.main, 0.8),
                    },
                    _d["& ." + chipClasses.deleteIcon] = (_e = {
                            color: alpha(theme.palette.error.main, 0.8)
                        },
                        _e["&:hover"] = {
                            color: theme.palette.error.main,
                        },
                        _e),
                    _d),
            },
            {
                props: { variant: 'twoTone', color: 'success' },
                style: (_f = {
                        color: theme.palette.success.main,
                        backgroundColor: alpha(theme.palette.success.main, 0.15)
                    },
                    _f["&:hover"] = {
                        backgroundColor: alpha(theme.palette.success.main, 0.18),
                    },
                    _f["& ." + chipClasses.icon] = {
                        color: alpha(theme.palette.success.main, 0.8),
                    },
                    _f["& ." + chipClasses.deleteIcon] = (_g = {
                            color: alpha(theme.palette.success.main, 0.8)
                        },
                        _g["&:hover"] = {
                            color: theme.palette.success.main,
                        },
                        _g),
                    _f),
            },
            {
                props: { variant: 'twoTone', color: 'info' },
                style: (_h = {
                        color: theme.palette.info.main,
                        backgroundColor: alpha(theme.palette.info.main, 0.15)
                    },
                    _h["&:hover"] = {
                        backgroundColor: alpha(theme.palette.info.main, 0.18),
                    },
                    _h["& ." + chipClasses.icon] = {
                        color: alpha(theme.palette.info.main, 0.8),
                    },
                    _h["& ." + chipClasses.deleteIcon] = (_j = {
                            color: alpha(theme.palette.info.main, 0.8)
                        },
                        _j["&:hover"] = {
                            color: theme.palette.info.main,
                        },
                        _j),
                    _h),
            },
            {
                props: { variant: 'twoTone', color: 'secondary' },
                style: (_k = {
                        color: theme.palette.secondary.main,
                        backgroundColor: alpha(theme.palette.secondary.main, 0.15)
                    },
                    _k["&:hover"] = {
                        backgroundColor: alpha(theme.palette.secondary.main, 0.18),
                    },
                    _k["& ." + chipClasses.icon] = {
                        color: alpha(theme.palette.secondary.main, 0.8),
                    },
                    _k["& ." + chipClasses.deleteIcon] = (_l = {
                            color: alpha(theme.palette.secondary.main, 0.8)
                        },
                        _l["&:hover"] = {
                            color: theme.palette.secondary.main,
                        },
                        _l),
                    _k),
            },
            {
                props: { variant: 'twoTone', color: 'warning' },
                style: (_m = {
                        color: theme.palette.warning.main,
                        backgroundColor: alpha(theme.palette.warning.main, 0.15)
                    },
                    _m["&:hover"] = {
                        backgroundColor: alpha(theme.palette.warning.main, 0.18),
                    },
                    _m["& ." + chipClasses.icon] = {
                        color: alpha(theme.palette.warning.main, 0.8),
                    },
                    _m["& ." + chipClasses.deleteIcon] = (_o = {
                            color: alpha(theme.palette.warning.main, 0.8)
                        },
                        _o["&:hover"] = {
                            color: theme.palette.warning.main,
                        },
                        _o),
                    _m),
            },
            {
                props: { variant: 'twoTone', color: 'default' },
                style: (_p = {
                        color: alpha(theme.palette.text.primary, 0.8),
                        backgroundColor: alpha(theme.palette.text.primary, 0.08)
                    },
                    _p["&:hover"] = {
                        backgroundColor: alpha(theme.palette.text.primary, 0.12),
                    },
                    _p["& ." + chipClasses.icon] = {
                        color: alpha(theme.palette.text.primary, 0.8),
                    },
                    _p["& ." + chipClasses.deleteIcon] = (_q = {
                            color: alpha(theme.palette.text.primary, 0.8)
                        },
                        _q["&:hover"] = {
                            color: theme.palette.text.primary,
                        },
                        _q),
                    _p),
            },
        ],
    });
};

var muiButton = function (theme) { return ({
    variants: [
        {
            props: {
                size: 'small',
            },
            style: {
                fontSize: theme.typography.pxToRem(13),
                fontWeight: theme.typography.fontWeightMedium,
                lineHeight: 1.38,
                letterSpacing: 0.46,
                padding: '2px 8px',
            },
        },
        {
            props: {
                size: 'medium',
            },
            style: {
                fontSize: theme.typography.pxToRem(14),
                fontWeight: theme.typography.fontWeightMedium,
                lineHeight: 1.71,
                letterSpacing: 0.4,
                padding: '6px 16px',
            },
        },
        {
            props: {
                size: 'large',
            },
            style: {
                fontSize: theme.typography.pxToRem(15),
                fontWeight: theme.typography.fontWeightMedium,
                lineHeight: 1.73,
                letterSpacing: 0.3,
                padding: '11px 24px',
            },
        },
        {
            props: {
                size: 'small',
                variant: 'outlined',
            },
            style: {
                padding: '1px 8px',
            },
        },
        {
            props: {
                size: 'medium',
                variant: 'outlined',
            },
            style: {
                padding: '5px 16px',
            },
        },
        {
            props: {
                size: 'large',
                variant: 'outlined',
            },
            style: {
                padding: '10px 24px',
            },
        },
    ],
}); };

var muiDrawer = function (_theme) { return ({
    styleOverrides: {},
    defaultProps: {
        anchor: 'right',
    },
}); };

var muiStepper = function (_theme) { return ({
    styleOverrides: {},
}); };
var muiStepLabel = function (_theme) { return ({
    styleOverrides: {
        iconContainer: {},
    },
}); };
var muiStepIcon = function (theme) { return ({
    styleOverrides: {
        root: {
            // nice!
            // this let's us specify sizes in px but the result will be in rem and variable
            // based on theme.typography.htmlFontSize
            fontSize: theme.typography.pxToRem(40),
            '&.Mui-completed': {
                color: theme.palette.success.main,
            },
        },
    },
}); };
var muiStepConnector = function (_theme) { return ({
    styleOverrides: {
        root: {
            top: '20px',
            left: 'calc(-50% + 30px)',
            right: 'calc(50% + 30px)',
        },
    },
}); };

// source of the colors: https://www.figma.com/design/TueobED3R985BWFoT6mwiP/Helene-%7C-Styles?m=auto&node-id=57-4480&t=ELJnyUTSIGNAcSol-1
var backgroundImageColors = {
    dark: {
        0: 'none',
        2: 'rgba(255, 255, 255, 0.02)',
        4: 'rgba(255, 255, 255, 0.04)',
        6: 'rgba(255, 255, 255, 0.06)',
        8: 'rgba(255, 255, 255, 0.10)',
        12: 'rgba(255, 255, 255, 0.14)',
        24: 'rgba(255, 255, 255, 0.16)',
    },
    light: {
        0: 'none',
        2: 'rgba(0, 0, 0, 0.01)',
        4: 'rgba(0, 0, 0, 0.02)',
        6: 'rgba(0, 0, 0, 0.03)',
        8: 'rgba(0, 0, 0, 0.04)',
        12: 'rgba(0, 0, 0, 0.05)',
        24: 'rgba(0, 0, 0, 0.06)',
    },
};
// source of the elevations: https://www.figma.com/design/TueobED3R985BWFoT6mwiP/Helene-%7C-Styles?m=auto&node-id=1-231&t=ZcCvByVsqD91L7my-1
var elevations = {
    dark: {
        0: [
            '0px 2px 1px -1px rgba(0, 0, 0, 0.2)',
            '0px 1px 1px 0px rgba(0, 0, 0, 0.14)',
            '0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
        ],
        2: [
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2)',
            '0px 2px 2px 0px rgba(0, 0, 0, 0.14)',
            '0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
        ],
        4: [
            '0px 2px 4px -1px rgba(0, 0, 0, 0.2)',
            '0px 4px 5px 0px rgba(0, 0, 0, 0.14)',
            '0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
        ],
        6: [
            '0px 3px 5px -1px rgba(0, 0, 0, 0.2)',
            '0px 6px 10px 0px rgba(0, 0, 0, 0.14)',
            '0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
        ],
        8: [
            '0px 5px 5px -3px rgba(0, 0, 0, 0.2)',
            '0px 8px 10px 1px rgba(0, 0, 0, 0.14)',
            '0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
        ],
        12: [
            '0px 7px 8px -4px rgba(0, 0, 0, 0.2)',
            '0px 12px 17px 2px rgba(0, 0, 0, 0.14)',
            '0px 5px 22px 4px rgba(0, 0, 0, 0.12)',
        ],
        24: [
            '0px 11px 15px -7px rgba(0, 0, 0, 0.2)',
            '0px 24px 38px 3px rgba(0, 0, 0, 0.14)',
            '0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
        ],
    },
    light: {
        0: [
            '0px 0px 0px 1px rgba(238, 238, 238, 1) inset',
            '0px 0px 10px 0px rgba(0, 0, 0, 0.04)',
        ],
        2: [
            '0px 0px 0px 1px rgba(238, 238, 238, 1) inset',
            '0px 0px 10px 0px rgba(0, 0, 0, 0.04)',
        ],
        4: [
            '0px 0px 0px 1px rgba(238, 238, 238, 1) inset',
            '0px 0px 10px 0px rgba(0, 0, 0, 0.04)',
        ],
        6: [
            '0px 0px 0px 1px rgba(238, 238, 238, 1) inset',
            '0px 0px 10px 0px rgba(0, 0, 0, 0.04)',
        ],
        8: [
            '0px 0px 0px 1px rgba(238, 238, 238, 1) inset',
            '0px 0px 24px -8px rgba(0, 0, 0, 0.04)',
        ],
        12: [
            '0px 0px 0px 1px rgba(238, 238, 238, 1) inset',
            '0px 0px 24px -8px rgba(0, 0, 0, 0.04)',
        ],
        24: [
            '0px 0px 0px 1px rgba(238, 238, 238, 1) inset',
            '0px 0px 24px -8px rgba(0, 0, 0, 0.04)',
        ],
    },
};
var getElevationStyles = function (elevation, mode) {
    var color = backgroundImageColors[mode][elevation];
    return {
        boxShadow: elevations[mode][elevation].join(', '),
        backgroundImage: color === 'none' ? color : "linear-gradient(" + color + ", " + color + ")",
    };
};
var muiPaper = function (theme) { return ({
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState;
            return (__assign({}, (!(ownerState === null || ownerState === void 0 ? void 0 : ownerState.square) && {
                borderRadius: 2 * theme.shape.borderRadius,
            })));
        },
        elevation0: getElevationStyles(0, theme.palette.mode),
        elevation1: getElevationStyles(0, theme.palette.mode),
        elevation2: getElevationStyles(2, theme.palette.mode),
        elevation3: getElevationStyles(2, theme.palette.mode),
        elevation4: getElevationStyles(4, theme.palette.mode),
        elevation5: getElevationStyles(4, theme.palette.mode),
        elevation6: getElevationStyles(6, theme.palette.mode),
        elevation7: getElevationStyles(6, theme.palette.mode),
        elevation8: getElevationStyles(8, theme.palette.mode),
        elevation9: getElevationStyles(8, theme.palette.mode),
        elevation10: getElevationStyles(8, theme.palette.mode),
        elevation11: getElevationStyles(8, theme.palette.mode),
        elevation12: getElevationStyles(12, theme.palette.mode),
        elevation13: getElevationStyles(12, theme.palette.mode),
        elevation14: getElevationStyles(12, theme.palette.mode),
        elevation15: getElevationStyles(12, theme.palette.mode),
        elevation16: getElevationStyles(12, theme.palette.mode),
        elevation17: getElevationStyles(12, theme.palette.mode),
        elevation18: getElevationStyles(12, theme.palette.mode),
        elevation19: getElevationStyles(12, theme.palette.mode),
        elevation20: getElevationStyles(12, theme.palette.mode),
        elevation21: getElevationStyles(12, theme.palette.mode),
        elevation22: getElevationStyles(12, theme.palette.mode),
        elevation23: getElevationStyles(12, theme.palette.mode),
        elevation24: getElevationStyles(24, theme.palette.mode),
    },
}); };

// TODO: Maybe add this into theme when we resolve the greys
var alternatingRowOpacity = 0.1;
var muiTableRow = function (theme) {
    var _a, _b;
    return ({
        styleOverrides: {
            root: (_a = {},
                _a[":not(." + tableRowClasses.head + ")"] = (_b = {},
                    _b["&." + tableRowClasses.hover] = {
                        transition: 'background 0.15s',
                    },
                    _b["&:nth-of-type(odd)"] = {
                        backgroundColor: alpha(theme.palette.mode === 'dark'
                            ? theme.palette.common.white
                            : theme.palette.common.black, alternatingRowOpacity),
                        '&:hover': {
                            backgroundColor: alpha(theme.palette.mode === 'dark'
                                ? theme.palette.common.white
                                : theme.palette.common.black, alternatingRowOpacity + theme.palette.action.hoverOpacity),
                        },
                    },
                    _b),
                _a),
        },
    });
};

var muiTableCell = function (_theme) {
    var _a;
    return ({
        styleOverrides: {
            root: (_a = {
                    border: 0
                },
                _a["&." + tableCellClasses.head] = {
                    lineHeight: 1.43,
                },
                _a),
        },
    });
};

var muiTooltip = function (theme) { return ({
    defaultProps: {
        arrow: true,
        // All additional props passed to Tooltip are assigned to the children element.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        'data-tooltip-trigger': true,
    },
    // TODO: Fix this when we have elevation defined
    styleOverrides: {
        tooltip: {
            fontSize: theme.typography.pxToRem(10),
            textAlign: 'center',
            boxShadow: '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
            backgroundColor: '#24252B',
            backgroundImage: "linear-gradient(" + alpha('#FFF', 0.16) + "," + alpha('#FFF', 0.16) + ")",
            fontWeight: theme.typography.fontWeightRegular,
            lineHeight: 1.4,
            letterSpacing: '0.4px',
        },
        arrow: {
            color: '#47484d',
        },
    },
}); };

var muiMenu = function (_theme) { return ({
    defaultProps: {
        elevation: 24,
    },
    styleOverrides: {},
}); };
var muiMenuItem = function (_theme) { return ({
    styleOverrides: {},
}); };

var muiPopover = function (_theme) { return ({
    styleOverrides: {},
}); };

var muiButtonGroup = function (theme) { return ({
// styleOverrides: {
//   root: {
//     borderRadius: muiButton(theme).styleOverrides.root.borderRadius,
//   },
// },
}); };

var trackDarkColor = '#32333b';
var thumbDarkColor = '#696969';
var trackLightColor = '#f0f2f3';
var thumbLightColor = '#696969';
var muiCssBaseline = function (theme) {
    var trackColor = theme.palette.mode === 'dark' ? trackDarkColor : trackLightColor;
    var thumbColor = theme.palette.mode === 'dark' ? thumbDarkColor : thumbLightColor;
    return {
        styleOverrides: {
            body: {
                scrollbarColor: thumbColor + " " + trackColor,
                '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                    backgroundColor: trackColor,
                    width: 8,
                },
                scrollbarWidth: 'thin',
                '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                    borderRadius: 8,
                    backgroundColor: thumbColor,
                    minHeight: 24,
                },
                '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
                    backgroundColor: thumbColor,
                },
                '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
                    backgroundColor: thumbColor,
                },
                '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: thumbColor,
                },
                '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
                    backgroundColor: trackColor,
                },
            },
        },
    };
};

var muiAlert = function (theme) { return ({
    styleOverrides: {
        // TODO: Remove the `ownerState` conditions when this is resolved
        // https://github.com/mui/material-ui/issues/32799
        root: function (_a) {
            var ownerState = _a.ownerState;
            return ownerState && __assign({}, (ownerState.variant === 'filled' && {
                backgroundColor: theme.palette[ownerState.color || ownerState.severity].main,
                color: theme.palette.getContrastText(theme.palette[ownerState.color || ownerState.severity].main),
            }));
        },
    },
}); };

var muiSelect = function (_theme) { return ({
    defaultProps: {
        IconComponent: function (args) { return React.createElement(ArrowDropDownRounded, __assign({}, args)); },
    },
}); };

var resolveTheme = function (mode, customOptions) {
    var resolvedOptions = merge(commonThemeOptions, mode === 'dark' ? darkThemeOptions : lightThemeOptions, customOptions);
    var theme = createTheme(resolvedOptions);
    // TODO: `theme` is now available inside `styleOverrides`, these no longer need to be functions
    theme.components = merge(theme.components, {
        MuiCssBaseline: muiCssBaseline(theme),
        MuiSelect: muiSelect(),
        MuiAutocomplete: muiAutocomplete(),
        MuiChip: muiChip(theme),
        MuiButton: muiButton(theme),
        MuiButtonGroup: muiButtonGroup(),
        MuiDrawer: muiDrawer(),
        MuiPaper: muiPaper(theme),
        MuiStepper: muiStepper(),
        MuiStepLabel: muiStepLabel(),
        MuiStepIcon: muiStepIcon(theme),
        MuiStepConnector: muiStepConnector(),
        MuiTableCell: muiTableCell(),
        MuiTableRow: muiTableRow(theme),
        MuiTooltip: muiTooltip(theme),
        MuiMenu: muiMenu(),
        MuiMenuItem: muiMenuItem(),
        MuiPopover: muiPopover(),
        MuiAlert: muiAlert(theme),
    });
    // Adapted from https://www.figma.com/file/AaBwZVqcfaoe476bCiLqmJ/Rossum-Design-System-%E2%80%94-Dark?node-id=6785%3A43358
    // we need to do this here for accessing theme utilities like `pxToRem`
    // TODO: Resolve this better + document ^^
    theme.typography = merge(theme.typography, {
        h1: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(48),
            lineHeight: 1.21,
            letterSpacing: -0.25,
        },
        h2: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(40),
            lineHeight: 1.5,
            letterSpacing: -0.1,
        },
        h3: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(32),
            lineHeight: 1.31,
            letterSpacing: 0,
        },
        h4: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(24),
            lineHeight: 1.33,
            letterSpacing: 0.1,
        },
        h5: {
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(20),
            lineHeight: 1.3,
            letterSpacing: 0.15,
        },
        h6: {
            fontWeight: theme.typography.fontWeightBold,
            fontSize: theme.typography.pxToRem(16),
            lineHeight: 1.37,
            letterSpacing: 0.2,
        },
        subtitle1: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(16),
            lineHeight: 1.75,
            letterSpacing: 0.15,
        },
        subtitle2: {
            fontWeight: theme.typography.fontWeightBold,
            fontSize: theme.typography.pxToRem(14),
            lineHeight: 1.57,
            letterSpacing: 0.2,
        },
        body1: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(16),
            lineHeight: 1.56,
            letterSpacing: 0.15,
        },
        body2: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(14),
            lineHeight: 1.57,
            letterSpacing: 0.15,
        },
        button: {
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: theme.typography.pxToRem(15),
            lineHeight: 1.73,
            letterSpacing: 0.3,
            textTransform: 'none',
        },
        caption: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.5,
            letterSpacing: 0.4,
        },
        overline: {
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 2.66,
            letterSpacing: 1,
        },
    });
    return theme;
};

var setCssVariables = function (variables) {
    return Object.keys(variables).forEach(function (cssVariable) {
        return document.documentElement.style.setProperty(cssVariable, variables[cssVariable]);
    });
};
var themes = {
    dark: darkTheme,
    white: whiteTheme,
};
var setTheme = function (themeType) {
    var theme = themes[themeType];
    setCssVariables(theme);
};
var primaryColor = '#2F72FF';
var getPrimaryColors = function (primary) {
    if (primary === void 0) { primary = primaryColor; }
    return ({
        '--color-primary': primary,
        '--color-primary-light': Color(primary).lighten(0.1).hex(),
        '--color-primary-lighter': Color(primary).lighten(0.25).saturate(1).hex(),
        '--color-primary-dark': Color(primary).darken(0.09).hex(),
        '--color-primary-darker': Color(primary).darken(0.35).hex(),
        '--color-primary-disabled': Color(primary).darken(0.4).desaturate(0.5).hex(),
        '--color-primary-bright': Color(primary)
            .hue(Color(primary).hue() - 20)
            .darken(0.1)
            .hex(),
    });
};
var setPrimaryColors = function (primary) {
    if (primary === void 0) { primary = primaryColor; }
    return setCssVariables(getPrimaryColors(primary));
};
var defaultRadiuses = {
    large: 15,
    medium: 10,
    small: 5,
    tiny: 3,
};
var setBorderRadiuses = function (radiuses) {
    if (radiuses === void 0) { radiuses = defaultRadiuses; }
    var radiusesToSet = Object.keys(defaultRadiuses).reduce(function (acc, size) {
        var _a;
        var _b;
        return (__assign(__assign({}, acc), (_a = {}, _a["--border-radius-" + size] = ((_b = radiuses[size]) !== null && _b !== void 0 ? _b : defaultRadiuses[size]) + "px", _a)));
    }, {});
    setCssVariables(radiusesToSet);
};

export { commonThemeOptions, darkThemeOptions, defaultRadiuses, getPrimaryColors, lightThemeOptions, primaryColor, resolveTheme, setBorderRadiuses, setCssVariables, setPrimaryColors, setTheme, themes };
